import type { Notification } from "./Notification";
import type { Snackbar } from "@/Modules/App/Models/Domain/Snackbar";
import type { iconName, iconSize } from "../Styles/Icons";
import type { colorTag } from "../Styles/Colors";
import type { Choice } from "@/Modules/Models/Domain/Choice";
import type { VersionConfig } from "@/Modules/Models/Api/Versions";

export interface Icon {
  iconName: iconName;

  size?: iconSize;
  color?: colorTag;
  background?: colorTag;
  className?: string;
}

export enum DEVICE_TYPE {
  "MOBILE" = "MOBILE",
  "DESKTOP" = "DESKTOP",
}

export interface AppState {
  isLoading: boolean;
  isSideMenuOpened: boolean;
  notification: Notification | null;
  snackbar?: Snackbar;
  endIconSidebar: Icon | null;
  isOnline: boolean;
  viewportHeight: number;
  viewportWidth: number;
  device: DEVICE_TYPE;
  cancelReasons: Choice[];
  needUpdate: boolean;
  isForceUpdate: boolean;
  versionRequirements?: VersionConfig<string | number>;
  isForeground: boolean;
  isKeyboardOpen: boolean;
  isVisibleNavigation: boolean;
}

export enum PLATFORM_TYPE {
  "IOS" = "IOS",
  "ANDROID" = "ANDROID",
  "WEB_MOBILE" = "WEB-MOBILE",
  "WEB_DESKTOP" = "WEB-DESKTOP",
}
